/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetMediaUserProfileResponseAllOf,
    GetMediaUserProfileResponseAllOfFromJSON,
    GetMediaUserProfileResponseAllOfFromJSONTyped,
    GetMediaUserProfileResponseAllOfToJSON,
} from './GetMediaUserProfileResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    MediaUserProfileResponseData,
    MediaUserProfileResponseDataFromJSON,
    MediaUserProfileResponseDataFromJSONTyped,
    MediaUserProfileResponseDataToJSON,
} from './MediaUserProfileResponseData';

/**
 * 
 * @export
 * @interface GetMediaUserProfileResponse
 */
export interface GetMediaUserProfileResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetMediaUserProfileResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetMediaUserProfileResponse
     */
    message: string;
    /**
     * 
     * @type {MediaUserProfileResponseData}
     * @memberof GetMediaUserProfileResponse
     */
    data: MediaUserProfileResponseData;
}

export function GetMediaUserProfileResponseFromJSON(json: any): GetMediaUserProfileResponse {
    return GetMediaUserProfileResponseFromJSONTyped(json, false);
}

export function GetMediaUserProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMediaUserProfileResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': MediaUserProfileResponseDataFromJSON(json['data']),
    };
}

export function GetMediaUserProfileResponseToJSON(value?: GetMediaUserProfileResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': MediaUserProfileResponseDataToJSON(value.data),
    };
}

